import { ReferenceLinkMapper } from '../../../../common/mappers/ReferenceLinkMapper';
import { RemediationMapper } from '../../../../common/mappers/RemediationMapper';
import { SeverityMapper } from '../../../../common/mappers/SeverityMapper';
import { ReportPrintMapper } from '../../report/mappers/ReportPrintMapper';
import { InstancePrintData } from '../models/InstancePrintData';
import { Issue } from '../models/valueObjects/Issue';

export class InstancePrintMapper {
  private readonly remediationMapper = new RemediationMapper();
  private readonly referenceMapper = new ReferenceLinkMapper();
  private readonly reportSummaryMapper = new ReportPrintMapper();
  private readonly severityMapper = new SeverityMapper();

  mapGQLModel(data: any, reportData: any): InstancePrintData {
    const issue = this.mapIssue(reportData.rules);
    const report = this.reportSummaryMapper.mapGQLModel(reportData);
    const [remediation, specifigTag] = data.remediation
      ? [this.remediationMapper.mapGQLModel(data.remediation), this.remediationMapper.mapSpecificTag(data.remediation)]
      : [null, null];
    const hardCodedLocationsCount = Array.isArray(data.hardCodedStringLocations) ? data.hardCodedStringLocations.length : 0;

    return new InstancePrintData(
      data.number,
      data.numberLocal,
      this.severityMapper.mapSeverity(data.severity),
      data.data,
      data.filterStatus,
      remediation,
      specifigTag,
      issue,
      report,
      data.calls?.totalCount ?? 0,
      data.operations?.totalCount ?? 0,
      (data.locations?.totalCount ?? 0) + hardCodedLocationsCount
    );
  }

  private mapIssue(data: any): Issue | null {
    const rule = data?.edges[0]?.node;
    if (!rule) return null;
    return new Issue(
      rule.number,
      rule.title,
      this.severityMapper.mapSeverity(rule.severity),
      rule.shortExplanation,
      rule.explanation,
      rule.consequences,
      rule.access,
      rule.expertise,
      rule.resources,
      this.referenceMapper.mapFromKbLink(rule)
    );
  }
}
